import { createAsyncThunk } from '@reduxjs/toolkit'
import {
  getMemberInterestPage,
  getMemberInterestDetail,
  submitMemberInterest,
  submitMemberInterestBatch,
  getMemberInterestExceptionPage,
  submitMemberInterestException,
  deleteMemberInterest,
  MemberInterestPageParams,
  MemberInterestDetailParams,
  MemberInterestExceptionPageParams,
} from '../../services/memberBenefits'
import { RootThunkApi } from '../../app/store'
import { sendAsync } from '../../app/applicationSlice'

export const getMemberInterestPageAsync = createAsyncThunk<
  void,
  MemberInterestPageParams,
  RootThunkApi
>('memberBenefits/getPage', async (params, api) => {
  return sendAsync(getMemberInterestPage(params), api)
})

export const getMemberInterestDetailAsync = createAsyncThunk<
  void,
  MemberInterestDetailParams,
  RootThunkApi
>('memberBenefits/getDetail', async (params, api) => {
  return sendAsync(getMemberInterestDetail(params), api)
})

export const submitMemberInterestAsync = createAsyncThunk<
  void,
  any,
  RootThunkApi
>('memberBenefits/submit', async (data, api) => {
  return sendAsync(submitMemberInterest(data), api)
})

export const submitMemberInterestBatchAsync = createAsyncThunk<
  void,
  any,
  RootThunkApi
>('memberBenefits/submitBatch', async (data, api) => {
  return sendAsync(submitMemberInterestBatch(data), api)
})

export const getMemberInterestExceptionPageAsync = createAsyncThunk<
  void,
  MemberInterestExceptionPageParams,
  RootThunkApi
>('memberBenefits/getExceptionPage', async (params, api) => {
  return sendAsync(getMemberInterestExceptionPage(params), api)
})

export const submitMemberInterestExceptionAsync = createAsyncThunk<
  void,
  any,
  RootThunkApi
>('memberBenefits/submitException', async (data, api) => {
  return sendAsync(submitMemberInterestException(data), api)
})

export const deleteMemberInterestAsync = createAsyncThunk<
  void,
  { id: string | number },
  RootThunkApi
>('memberBenefits/delete', async (data, api) => {
  return sendAsync(deleteMemberInterest(data), api)
})
